import { jsx as n, jsxs as i } from "react/jsx-runtime";
import * as a from "@radix-ui/react-accordion";
import e from "./accordion.module.less.js";
import { useState as m } from "react";
const p = ({ id: r, heading: c, content: d, disabled: s = !1 }) => /* @__PURE__ */ i(a.Item, { value: r, className: e.accordionItem, children: [
  /* @__PURE__ */ n(a.Header, { className: e.accordionHeader, children: /* @__PURE__ */ n(a.Trigger, { disabled: s, className: e.accordionItemHeader, children: /* @__PURE__ */ i("div", { className: e.accordionItemHeaderInnerWrapper, children: [
    /* @__PURE__ */ n("span", { className: ["body-base bold", e.accordionItemHeading].join(" "), children: c }),
    /* @__PURE__ */ n("span", { "aria-hidden": !0, className: [e.expandIcon, "ui-icon-chevron-down"].join(" ") })
  ] }) }) }),
  /* @__PURE__ */ n(a.Content, { className: e.accordionContent, children: /* @__PURE__ */ n("div", { className: e.accordionContentInnerWrapper, children: d }) })
] }), N = ({ items: r, isBlock: c }) => {
  const d = r.filter((o) => o.open).map((o) => o.id), [s, t] = m(d);
  return /* @__PURE__ */ n(
    a.Root,
    {
      className: e.accordionRoot,
      value: s,
      onValueChange: (o) => {
        t(o);
      },
      type: "multiple",
      children: r.map((o, l) => /* @__PURE__ */ n(p, { isBlock: c, ...o }, `${o.id}-${l}`))
    }
  );
};
export {
  N as Accordion,
  N as default
};
